.logo {
    width: 160px;
    height: 24px;
    aspect-ratio: 160 / 24;
}

.headline {
    color: var(--sidebar-primary);
    font-family: 'Doyle', 'Georgia', sans-serif;
    font-size: 48px;
    font-weight: 700;
    line-height: 48px;
    margin: 0;
}

.hourglass {
    width: auto;
    height: auto;
    max-width: 65%;
    max-height: 55%;
    object-fit: contain;
}
